import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './store/auth'
import './style.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// P1-5 修复：启动时恢复登录态（token + me），
// 否则 router 守卫跑在前，is_approved 等状态未及时同步。
useAuthStore().init()

app.use(router)

app.mount('#app')